import * as _ from 'lodash';
import React, { useState, useEffect, useContext, useRef } from 'react';
import useFetch from 'use-http';
// import State from 'src/models/State';
import Project from 'src/models/Project';
import PBNavBar from '../PBNavBar';
import { useForm } from 'react-hook-form';
import actions from 'src/actions';
import { useDispatch } from 'react-redux';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import { UserRoles } from 'src/models/UserRole';
import DialogList from 'src/dialogs';
import ExcelFileDialog from '../dialogs/ExcelFileDialog';
import CollapsibleSection from 'src/components/common/CollapsibleSection';
// import Expense from 'src/models/AP/Expense';
import PayPeriod from 'src/models/AP/PayPeriod';
import Form from 'src/components/controls/forms/Form';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
import FormToggle from 'src/components/controls/forms/redesign/FormToggle';
import FormLabel from 'src/components/controls/forms/FormLabel';
import { BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { FaCheckCircle, FaFlag, FaUndo, FaPenSquare } from 'react-icons/fa';
import { ODataFilter, ODataOptions, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import FindManagerDialog from '../dialogs/FindManagerDialog';
import Landman from 'src/models/Landman';
import BillingApproval from 'src/models/AP/BillingApproval';
import TimeAndExpense from 'src/models/AP/TimeAndExpense';
// import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import ClientBillingInfo from 'src/models/ClientBillingInfo';
import ClientProjectSearch from '../components/ClientProjectSearch';
import FlagNoteDialog from '../dialogs/FlagNoteDialog';
import FlagNote from 'src/models/AP/FlagNote';
import ViewFlagNotesDialog from '../dialogs/ViewFlagNotesDialog';
import TsdiClient from 'src/models/AP/Client';

// import { SelectItem } from 'src/models/common/SelectItem';

const ProjectBillingPage = () => {
    const appContext = useContext<IAppContextState>(AppContext);
    const isAccountingAdmin = appContext.currentUser.role === UserRoles.Admin; // .AccountingAdmin;
    const dispatch = useDispatch();
    // const { get, post, del, put, response } = useFetch();
    const { get, put, post, response } = useFetch();
    // const { register, reset, setValue, getValues, handleSubmit, errors, formState } = useForm();
    const { register, handleSubmit, errors, reset } = useForm();
    const {
        register: registerBillingApprovalsForm,
        handleSubmit: handleSubmitBillingApprovalsForm,
        reset: resetBillingApprovalsForm
      } = useForm();
    const [managers, setManagers] = useState<Landman[]>(undefined);
    const [clientBillingInfo, setClientBillingInfo] = useState<ClientBillingInfo>(undefined);
    const [projects, setProjects] = useState<Project[]>(undefined);
    // const [timeAndExpenses, setTimeAndExpenses] = useState<Array<Expense>>(undefined);
    const [payPeriods, setPayPeriods] = useState<Array<{id: number | string, name: string}>>(undefined);
    const [dlcOffices, setDlcOffices] = useState<Array<{value: number | string, label: string}>>(undefined);
    const [showPreviousBilling, setShowPreviousBilling] = useState<boolean>(false);
    const [showViewFlagNotes, setShowViewFlagNotes] = useState<boolean>(false);
    const [noteMode, setNoteMode] = useState<boolean>(false);
    const [billingApprovalsRendered, setBillingApprovalsRendered] = useState<boolean>(false);
    const [selectedManager, setSelectedManager] = useState<string>(undefined);
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [selectedPayPeriod, setSelectedPayPeriod] = useState<string>(undefined);
    const [restoreSelectedBillingApprovalRowIndex, setRestoreSelectedBillingApprovalRowIndex] = useState<number>(undefined);
    const [selectedBillingApprovalRowIndex, setSelectedBillingApprovalRowIndex] = useState<number>(undefined);
    const [billingApprovals, setBillingApprovals] = useState<BillingApproval[]>(undefined);
    const [billingApprovalProjectInfo, setBillingApprovalProjectInfo] = useState<BillingApproval>(undefined);
    const [billingExpenses, setBillingExpenses] = useState<TimeAndExpense[]>(undefined);
    const [flagAndCorrectionNotes, setFlagAndCorrectionNotes] = useState<FlagNote[]>(undefined);
    const selectedBillingApprovalRowIndexRef = useRef(selectedBillingApprovalRowIndex);
    const billingApprovalsLengthRef = useRef(null);
    
    // const [collapseTneSection, setCollapseTneSection] = useState<boolean>(false);
    // const { isDirty, dirtyFields } = formState;

    const approvalStates = {
        approved: 1,
        corrected: 2,
        flagged: 3
    };

    const statusOptionValues = [
        {value: '0', label: 'ALL'},
        {value: '2', label: 'Waiting'},
        {value: '3', label: 'Corrected'},
        {value: '1', label: 'Approved'},
        {value: '5', label: 'Flagged'}
    ];
    const officeOptionValues = [
        {value: '1', label: 'ALL'},
        {value: '2', label: 'CO'},
        {value: '3', label: 'IH'},
        {value: '4', label: 'MD'},
        {value: '5', label: 'OK'},
        {value: '6', label: 'PA'},
        {value: '7', label: 'RN'},
        {value: '8', label: 'TX'}
    ];

/*     const timeAndExpenseData = [
        { name: 'Quan shoo', number: 1, acctNo: 200, days: 2, periodDays: 2, billRate: 250, payRate: 400,
            billedServices: 10, miles: 10, mileage: 20, meals: 200, hotel: 200, copies: 100, phone: 50}
        ]; */

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!billingApprovalsRendered && !!billingApprovals && billingApprovals.length > 0) {
            setBillingApprovalsRendered(false);
        }
    }, [billingApprovalsRendered]);

    useEffect(() => {
        if (selectedBillingApprovalRowIndex !== undefined) {
            selectedBillingApprovalRowIndexRef.current = selectedBillingApprovalRowIndex;
            if (!!billingApprovals && billingApprovals.length > 0 && !!billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber) {
                getBillingApprovalProjectInfo();
                getClientBillingInfo(billingApprovals[selectedBillingApprovalRowIndex].clientNumber);
                getFlagAndCorrectionNotes();
            }
        }
    }, [selectedBillingApprovalRowIndex]);

    useEffect(() => {
        if (!!billingApprovals && billingApprovals?.length > 0) {
            billingApprovalsLengthRef.current = billingApprovals.length;
            if (restoreSelectedBillingApprovalRowIndex !== undefined) {
                setSelectedBillingApprovalRowIndex(restoreSelectedBillingApprovalRowIndex);
                setRestoreSelectedBillingApprovalRowIndex(undefined);
            } else {                
                setSelectedBillingApprovalRowIndex(0);
            }
            resetBillingApprovalsForm(billingApprovals);
            setBillingApprovalsRendered(false);
            getFlagAndCorrectionNotes();
        }
    }, [billingApprovals]);

/*     useEffect(() => {
        if (!!selectedPayPeriod && selectedPayPeriod.length > 0) {
            alert('Get data for the screen as if Query was selected');
        }
    }, [selectedPayPeriod]); */

    const onCreate = () => {
        // Put all initialization code here.
        reset(!!billingExpenses ? billingExpenses : new TimeAndExpense());
        setDlcOffices(officeOptionValues);
        resetBillingApprovalsForm();
        setBillingApprovals([]);
        getPayPeriods();
        getManagers();
        if (!projects) {
            setProjects([new Project()]);
        }

        document.addEventListener('keydown', handleKeyDown);
    };

    const onDestroy = () => {
        document.removeEventListener('keydown', handleKeyDown);
    };

    const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'ArrowDown') {
        moveToNextRecord();
    } else if (e.key === 'ArrowUp') {
        moveToPreviousRecord();
    }
    };

    const onSubmit = () => {
        // Put all form saving/validation code here.
    };

    const setSelectedManagerNumber = (managerNumber: string) => {
        setSelectedManager(managerNumber);
        // const managerNumberElement = document.getElementById('lmsNumber') as HTMLInputElement;
        // managerNumberElement.value = managerNumber;
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
        if (!!showViewFlagNotes) {
            showFlagNotesDialog();
            setShowViewFlagNotes(false);
        }
    };

    const handleFlagBillingEntry = (reason: string) => {
        const flagNote = {
            billingId: billingApprovals[selectedBillingApprovalRowIndex].billingId,
            note: reason,
            owner: appContext.currentUser.username.split('@')[0],
            type: noteMode === false ? 'F' : 'C',
            created: new Date()
        };
        addFlagNote(flagNote);
        setRestoreSelectedBillingApprovalRowIndex(selectedBillingApprovalRowIndex);
        const approvalUpdatepayload = generateBillingApprovalUpdatePayload(flagNote.type === 'F' ? approvalStates.flagged : approvalStates.corrected);
        updateBillingApproval(approvalUpdatepayload);
    };

    const loadData = () => {
        setBillingApprovals([]);
        getBillingApprovals();
    };

    const refresh = () => {
        alert('Todo: refresh all the junk DLC Menus does.');
    };

    const showReportsDialog = () => {
        alert('Todo: Create a dialog for reports like DLC Menus.');
    };

    const expandAllPanels = () => {
        alert('Todo: Expand all the collapsible panels like DLC Menus.');
    };

    const collapseAllPanels = () => {
        // setCollapseTneSection(true);
        alert('Todo: Collapse all the collapsible panels like DLC Menus.');
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const exportToExcel = () => {        
        showDialog(DialogList.EXCEL_FILE);
        // alert('Todo: Create a dialog for exporting to Excel file like DLC Menus.');
    };

    const personnelSummary = () => {
        alert('Todo: Create a Personnel Summary dialog like DLC Menus.');
    };

    const showFlagReasonDialog = () => {
        dispatch(actions.layout.showDialog(DialogList.FLAG_REASON_DIALOG));
    };

    const showFlagNotesDialog = () => {
        dispatch(actions.layout.showDialog(DialogList.SHOW_FLAG_NOTES_DIALOG));
    };

    const onApprovalStatus = (status: number) => {
        if (isNaN(status) || status === 1) {
            status = null;
        } else {
            status = 1;
        }
        const approvalUpdatepayload = generateBillingApprovalUpdatePayload(status);
        updateBillingApproval(approvalUpdatepayload);
    };

    const onChangeShowPreviousBilling = () => {
        setShowPreviousBilling(!showPreviousBilling);
    };

    const moveToLastRecord = () => {
        alert('Todo: Approve expenses a la DLC Menus.');
    };

    const moveToFirstRecord = () => {
        alert('Todo: Approve expenses a la DLC Menus.');
    };

    const moveToNextRecord = () => {
        // alert('Todo: Approve expenses a la DLC Menus.');
        if (selectedBillingApprovalRowIndexRef.current < billingApprovalsLengthRef.current) {
            setSelectedBillingApprovalRowIndex(selectedBillingApprovalRowIndexRef.current + 1);
            const billingApprovalRow = document.getElementById('billingApprovalRow' + (selectedBillingApprovalRowIndexRef.current + 1).toString());
            billingApprovalRow.focus();
        }
    };

    const moveToPreviousRecord = () => {
        // alert('Todo: Approve expenses a la DLC Menus.');
        if (selectedBillingApprovalRowIndexRef.current > 0) {
            setSelectedBillingApprovalRowIndex(selectedBillingApprovalRowIndexRef.current - 1);
            const billingApprovalRow = document.getElementById('billingApprovalRow' + (selectedBillingApprovalRowIndexRef.current - 1).toString());
            billingApprovalRow.focus();
        }
    };

    const initializePayPeriodSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        const payPeriodSearchOptions = ODataOptions.from(tableConfig);
        payPeriodSearchOptions.addOrderBy('Id', ODataOrderByDirection.Descending);
        const currentDate = new Date();
        const currentDate2 = new Date();
        const beginDate = new Date(currentDate.setMonth(currentDate.getMonth() - 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        const endDate = new Date(currentDate2.setMonth(currentDate2.getMonth() + 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        payPeriodSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThan, endDate));
        payPeriodSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThan, beginDate));
        
        return payPeriodSearchOptions.toString();
    };

    const initializeBillingApprovalProjectInfoSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 1,
            idField: 'PR_ID',
            pageNumber: 1,
            columns: []
        };
        const billingApprovalsSearchOptions = ODataOptions.from(tableConfig);
        billingApprovalsSearchOptions.addOrderBy('PR_ID', ODataOrderByDirection.Descending);
        if (!!selectedManager && selectedManager.length > 0) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('pba.[tsd_mgr]', ODataFilterOperators.Equals, selectedManager));
        }
        if (!!selectedPayPeriod && selectedPayPeriod.length > 0) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('pba.[period_no]', ODataFilterOperators.Equals, selectedPayPeriod.replace('-', '')));
        }
        if ( selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('pba.[cl_no]', ODataFilterOperators.Equals, billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber?.toString()));
        }
        if ( selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.acctNo) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('psi.ACCT_NO', ODataFilterOperators.Equals, billingApprovals[selectedBillingApprovalRowIndex]?.acctNo?.toString()));
        }
        if ( selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.projectId) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('pba.[pr_id]', ODataFilterOperators.Equals, billingApprovals[selectedBillingApprovalRowIndex]?.projectId?.toString()));
        }
        if ( selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.projectNo) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('pba.[pr_no]', ODataFilterOperators.Equals, billingApprovals[selectedBillingApprovalRowIndex]?.projectNo?.toString()));
        }
        // billingApprovalsSearchOptions?.addFilter(new ODataFilter('LM.State', ODataFilterOperators.Equals, 'p.OFFICE'));
        return billingApprovalsSearchOptions.toString();
    };

    const initializeFlagAndCorrectionNotesSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'NOTE_ID',
            pageNumber: 1,
            columns: []
        };
        const flagAndCorrectionNoteSearchOptions = ODataOptions.from(tableConfig);
        flagAndCorrectionNoteSearchOptions.addOrderBy('NOTE_BY', ODataOrderByDirection.Ascending);
        if ( selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.billingId) {
            flagAndCorrectionNoteSearchOptions?.addFilter(new ODataFilter('[BILL_ID]', ODataFilterOperators.Equals, billingApprovals[selectedBillingApprovalRowIndex]?.billingId?.toString()));
        }
        
        return flagAndCorrectionNoteSearchOptions.toString();
    };

    const initializeBillingApprovalSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'PR_ID',
            pageNumber: 1,
            columns: []
        };
        const billingApprovalsSearchOptions = ODataOptions.from(tableConfig);
        billingApprovalsSearchOptions.addOrderBy('PR_NO', ODataOrderByDirection.Ascending);
        if (!!selectedManager && selectedManager.length > 0) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('[tsd_mgr]', ODataFilterOperators.Equals, selectedManager));
        }
        if (!!selectedPayPeriod && selectedPayPeriod.length > 0) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('[period_no]', ODataFilterOperators.Equals, selectedPayPeriod.replace('-', '')));
        }
        if (!!selectedClient && selectedClient?.clientNumber > 0) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('[cl_no]', ODataFilterOperators.Equals, selectedClient.toString()));
        }
        
        return billingApprovalsSearchOptions.toString();
    };

    const initializeBillingExpenseSearchSettings = (clientNumber: number, projectNumber: number) => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'PR_ID',
            pageNumber: 1,
            columns: []
        };
        const billingExpenseSearchOptions = ODataOptions.from(tableConfig);
        billingExpenseSearchOptions.addOrderBy('bte.[BILL_ID]', ODataOrderByDirection.Descending);
        if (!!selectedManager && selectedManager.length > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('[TSD_MGR]', ODataFilterOperators.Equals, selectedManager));
        }
        if (!!selectedPayPeriod && selectedPayPeriod.length > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('[PERIOD_NO]', ODataFilterOperators.Equals, selectedPayPeriod.replace('-', '')));
        }
        if (!!projectNumber && projectNumber > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('[PR_NO]', ODataFilterOperators.Equals, projectNumber));
        }
        if (!!clientNumber && clientNumber > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('[CL_NO]', ODataFilterOperators.Equals, clientNumber));
        }
        
        return billingExpenseSearchOptions.toString();
    };

    const initializeManagerSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        const managerSearchOptions = ODataOptions.from(tableConfig);
        managerSearchOptions.addOrderBy('Id', ODataOrderByDirection.Descending);
        const currentDate = new Date();
        const beginDate = new Date(currentDate.setMonth(currentDate.getMonth() - 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        currentDate.setMonth(new Date().getMonth());
        const endDate = new Date(currentDate.setMonth(currentDate.getMonth() + 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        managerSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThan, endDate));
        managerSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThan, beginDate));
        
        return managerSearchOptions.toString();
    };

    const getClientBillingInfo = async (clientNumber: number) => {        
        const result = await get(`/v1.0/ClientProjectMaintenance/client/billing/info/${clientNumber}`);

        if (response.ok) {
            console.log('Client Billing Info', result);
            setClientBillingInfo(result);
        }
    };

    const getPayPeriods = async () => {        
        const queryString = initializePayPeriodSearchSettings();
        let result = await get(`/v1.0/AccountsPayable/payperiods${queryString}`);

        if (response.ok) {
            setPayPeriods(result.items.map((pp: PayPeriod) => {
                const insertIndex = pp.periodNumber.toString().length - 2;
                const ppString = pp.periodNumber.toString().slice(0, insertIndex) + '-' + pp.periodNumber.toString().slice(insertIndex);
                return { id: pp.id, name: ppString };
            }));
        } else {
            console.log('Unable to get pay period data!!!');
        }
    };

    const getBillingApprovalProjectInfo = async () => {        
        const queryString = initializeBillingApprovalProjectInfoSearchSettings();
        let result = await get(`/v1.0/AccountsPayable/billing/approval/projectinfo${queryString}`);

        if (response.ok) {
            setBillingApprovalProjectInfo(result);
        } else {
            console.log('Unable to get billing approval project data!!!');
        }
    };

    const getBillingApprovals = async () => {        
        const queryString = initializeBillingApprovalSearchSettings();
        let result = await get(`/v1.0/AccountsPayable/billing/approvals${queryString}`);

        if (response.ok) {
            setBillingApprovals(result.items);
        } else {
            console.log('Unable to get billing approval data!!!');
        }
    };

    const addFlagNote = async (payload: FlagNote) => {    
        let result = await post(`/v1.0/AccountsPayable/billing/flagnote`, payload);

        if (response.ok) {
            console.log('Note added');
        } else {
            console.log('Unable to add flag note!' + result);
        }
    };

    const getFlagAndCorrectionNotes = async () => {
        setNoteMode(false);
        const queryString = initializeFlagAndCorrectionNotesSearchSettings();
        let result = await get(`/v1.0/AccountsPayable/billing/flagnotes${queryString}`);

        if (response.ok) {
            setFlagAndCorrectionNotes(result);
        } else {
            console.log('Unable to add flag note!' + result);
        }
    };

    const generateBillingApprovalUpdatePayload = (approvalStatus: number) => {
        const payload: BillingApproval = {
            payPeriod: selectedPayPeriod,
            clientNumber: billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber,
            managerNumber: !isNaN(Number(selectedManager)) ? Number(selectedManager) : null,
            projectNo: billingApprovals[selectedBillingApprovalRowIndex]?.projectNo,
            subCode: !!billingApprovals[selectedBillingApprovalRowIndex]?.subCode ? billingApprovals[selectedBillingApprovalRowIndex].subCode : null,
            altSubCode: !!billingApprovals[selectedBillingApprovalRowIndex]?.altSubCode ? billingApprovals[selectedBillingApprovalRowIndex].altSubCode : null,
            acctNo: !!billingApprovals[selectedBillingApprovalRowIndex]?.acctNo ? billingApprovals[selectedBillingApprovalRowIndex].acctNo : null,
            approvalDate: approvalStatus === 1 ? new Date() : null,
            modifiedDate: new Date(),
            approvalStatus: !!approvalStatus ? approvalStatus.toString() : null
        };

        return payload;
    };

    const updateBillingApproval = async (payload: BillingApproval) => {
        let result = await put(`/v1.0/AccountsPayable/billing/approvals`, payload);

        if (response.ok && result === 1) {
            setBillingApprovals([]);
            getBillingApprovals();
        } else {
            console.log('Unable to get billing approval data!!!');
        }
    };

    const getBillingExpensesAndSetSelectedIndex = async (clientNumber: number, projectNumber: number, index: number) => {
        setSelectedBillingApprovalRowIndex(index);
        getBillingExpenses(clientNumber, projectNumber);
    };

    const getBillingExpenses = async (clientNumber: number, projectNumber: number) => {
        const queryString = initializeBillingExpenseSearchSettings(clientNumber, projectNumber);
        let result = await get(`/v1.0/AccountsPayable/billing/expenses${queryString}`);

        if (response.ok) {
            setBillingExpenses(result.items);
        } else {
            console.log('Unable to get billing expense data!!!');
        }
    };

    const getManagers = async () => {        
        const queryString = initializeManagerSearchSettings();
        let result = await get(`/v1.0/ClientProjectMaintenance/project/managers${queryString}`);

        if (response.ok) {
            setManagers(result);
        } else {
            console.log('Unable to get manager data!!!');
        }
    };

    const setSelectedPayPeriodValue = (value: string) => {
        const labelValue: { id: string | number, name: string} = payPeriods.find((pp) =>
            pp.id.toString() === value
        );
        if (!!labelValue?.name) {
            setSelectedPayPeriod(labelValue.name.toString().replace('-', ''));
        }
    };

    const getStatusString = (status: string) => {
        switch (status) {
            case '1':
                return 'Approved';
            case '2':
                return 'Corrected';
            case '3':
                return 'Flagged';
            case null :
            default :
                return 'Waiting';
        }
    };

/*     const displayProjectBillingApprovals = (b: BillingApproval, index: number) => {
        return (
            <tr
                key={index}
                tabIndex={0}
                id={'billingApprovalRow' + index}
                onFocus={() => getBillingExpensesAndSetSelectedIndex(billingApprovals[index].clientNumber, billingApprovals[index].projectNo, index)}
                className="table-item-hover"
                style={{ textAlign: 'center' }}
            >
                <td style={{ width: '3%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].id`}
                        type="text"
                        defaultVal={b?.id?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '10%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].managerName`}
                        type="text"
                        defaultVal={b?.managerName}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].clientNumber`}
                        type="number"
                        defaultVal={b?.clientNumber?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '10%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].clientName`}
                        type="text"
                        defaultVal={b?.clientName}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{  width: '3%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].projectNo`}
                        defaultVal={b?.projectNo?.toString()}
                        style={{ width: '40px'}}
                        // TODO: Finish billing code validation
                        // style={(clientValidations?.length > 0 && !clientValidations[index]) ? { width: '40px', border: '2px solid red'} : { width: '40px'}}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                    />
                </td>
                <td style={{ width: '3%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].projectName`}
                        defaultVal={b?.projectName}
                        style={{ width: '100px'}}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                    />
                </td>
                <td style={{ width: '3%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].subCode`}
                        defaultVal={b?.subCode?.toString()}
                        style={{ width: '40px'}}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                    />
                </td>
                <td style={{ width: '8%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].sectionName`}
                        defaultVal={b?.sectionName}
                        style={{ width: '40px'}}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                    />
                </td>
                <td style={{ width: '4%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].altSubCode`}
                        defaultVal={b?.altSubCode?.toString()}
                        style={{ width: '40px'}}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                    />
                </td>
                <td style={{ width: '4%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].acctNo`}
                        defaultVal={b?.acctNo?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].billBy`}
                        register={registerBillingApprovalsForm}
                        defaultVal={b?.billBy?.toString()}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].invoicedBy`}
                        defaultVal={b?.invoicedBy?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].total`}
                        register={registerBillingApprovalsForm}
                        defaultVal={b?.total?.toString()}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].totalAfe`}                                        
                        defaultVal={b?.total?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].totalBilled`}                                        
                        defaultVal={b?.totalAfe?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].approvalDate`}                                        
                        defaultVal={b?.approvalDate?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].approvalStatus`}                                        
                        defaultVal={getStatusString(b?.approvalStatus?.toString())}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ color: 'black', backgroundColor: b?.approvalStatus === '1' ? '#66FF00' : '#26F7FD',  width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
            </tr>
        );
    };
 */
    const displayProjectBilling = () => {
        return  <table style={{textAlign: 'left'}}>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Manager</th>
                        <th>#</th>
                        <th>Client</th>
                        <th>#</th>
                        <th>Project</th>
                        <th title={'Subcode'}>SC</th>
                        <th>Survey</th>
                        <th title={'AltSubcode'}>ASC</th>
                        <th>Acct</th>
                        <th>BB</th>                        
                        <th>Invoiced By</th>
                        <th>Total</th>
                        <th>AFE Total</th>
                        <th>Total Billed</th>
                        <th>Approval Date</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody style={{width: '100%', maxHeight: '30vh', overflowY: 'scroll'}}>
                {billingApprovals && billingApprovals?.length > 0 && billingApprovals?.map(
                    (b: BillingApproval, index: number) => {
                    if (index === billingApprovals.length - 1 && !billingApprovalsRendered) {
                        setBillingApprovalsRendered(true);
                    }
                    return (
                            <tr
                                key={index}
                                tabIndex={0}
                                id={'billingApprovalRow' + index}
                                onFocus={() => getBillingExpensesAndSetSelectedIndex(billingApprovals[index].clientNumber, billingApprovals[index].projectNo, index)}
                                className="table-item-hover"
                                style={{ textAlign: 'center' }}
                            >
                                <td style={{ width: '4%' }}>
                                    <RHFInputBox
                                        name={`billingApprovals[${index}].id`}
                                        readOnly={true}
                                        type="text"
                                        defaultVal={b?.id?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '6%' }}>
                                    <RHFInputBox
                                        name={`billingApprovals[${index}].managerName`}
                                        readOnly={true}
                                        type="text"
                                        defaultVal={b?.managerName}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFInputBox
                                        name={`billingApprovals[${index}].clientNumber`}
                                        readOnly={true}
                                        type="text"
                                        defaultVal={b?.clientNumber?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].clientName`}
                                        type="text"
                                        defaultVal={b?.clientName}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{  width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].projectNo`}
                                        defaultVal={b?.projectNo?.toString()}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].projectName`}
                                        defaultVal={b?.projectName}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].subCode`}
                                        defaultVal={b?.subCode?.toString()}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].sectionName`}
                                        defaultVal={b?.sectionName}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].altSubCode`}
                                        defaultVal={b?.altSubCode?.toString()}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].acctNo`}
                                        defaultVal={b?.acctNo?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].billBy`}
                                        register={registerBillingApprovalsForm}
                                        defaultVal={b?.billBy?.toString()}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].invoicedBy`}
                                        defaultVal={b?.invoicedBy?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].total`}
                                        register={registerBillingApprovalsForm}
                                        defaultVal={b?.total?.toString()}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].totalAfe`}                                        
                                        defaultVal={b?.total?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].totalBilled`}                                        
                                        defaultVal={b?.totalAfe?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].approvalDate`}                                        
                                        defaultVal={b?.approvalDate?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={selectedBillingApprovalRowIndex && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '6%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].approvalStatus`}                                        
                                        defaultVal={getStatusString(b?.approvalStatus?.toString())}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={{ color: 'black', backgroundColor: b?.approvalStatus === '1' ? '#66FF00' :
                                            (b?.approvalStatus === '2' ? '#CC5500' :
                                                (b?.approvalStatus === '3' ? '#B22222' : '#26F7FD')),  width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                            </tr>

                    );
                })}
                </tbody>
            </table>;
    };

    const displayProjectInformation = () => {
        return (<>
            <Form
                onSubmit={loadData}
            >
                <FormRow>
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Client.Project No."
                        id={`prospect`}
                        readOnly={true}
                        defaultVal={!!billingApprovals && billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber !== undefined ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber?.toString() +
                                '.' + billingApprovals[selectedBillingApprovalRowIndex]?.projectNo : ''}
                        name={`prospect`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '450%' }}
                        bodyStyle={{ width: '45%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Client"
                        id={`clientName`}
                        name={`clientName`}
                        readOnly={true}
                        defaultVal={!!billingApprovals ? billingApprovals[selectedBillingApprovalRowIndex]?.clientName : ''}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '60%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Project"
                        id={`projectName`}
                        readOnly={true}
                        defaultVal={!!billingApprovals ? billingApprovals[selectedBillingApprovalRowIndex]?.projectName : ''}
                        name={`projectName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{display: 'flex', alignItems: 'baseline', width: '60%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label={'Subcode: '}
                        readOnly={true}
                        defaultVal={!!billingApprovals ? billingApprovals[selectedBillingApprovalRowIndex]?.sectionName?.toString() : ''}
                        id={`subCodeName`}
                        name={`subCodeName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '30%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label={'AltSubcode: '}
                        readOnly={true}
                        id={`altSubCodeName`}
                        name={`altSubCodeName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '40%' }}
                        bodyStyle={{ width: '40%' }}
                    />
                    <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                        <label>Billing Office:&nbsp;</label>
                        <label>{!!billingApprovalProjectInfo ? billingApprovalProjectInfo?.projectOffice : 'OK'}</label>
                    </div>
                    <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                        <label style={{fontWeight: 'bold'}}>{!!selectedBillingApprovalRowIndex ? selectedBillingApprovalRowIndex : 0}</label>
                        <label>&nbsp;of&nbsp;</label>
                        <label style={{fontWeight: 'bold'}}>{!!billingApprovals ? billingApprovals?.length : (!!selectedBillingApprovalRowIndex ? selectedBillingApprovalRowIndex : 0)}</label>
                    </div>
                </FormRow>
                <FormRow>
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Account Name"
                        id={`accountName`}
                        readOnly={true}
                        defaultVal={!!billingApprovalProjectInfo ? billingApprovalProjectInfo?.projectAccount : ''}
                        name={`accountName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '60%' }}
                        bodyStyle={{ width: '60%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Day Rate"
                        id={`dayRate`}
                        readOnly={true}
                        defaultVal={!!clientBillingInfo ? clientBillingInfo?.dayRate?.toString() : ''}
                        name={`dayRate`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '35%' }}
                        bodyStyle={{ width: '35%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Contact"
                        id={`contactName`}
                        readOnly={true}
                        defaultVal={!!clientBillingInfo ? clientBillingInfo?.contactName : ''}
                        name={`contactName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '40%' }}
                        bodyStyle={{ width: '40%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="County, State"
                        id={`countyAndState`}
                        readOnly={true}
                        name={`countyAndState`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '40%' }}
                        bodyStyle={{ width: '40%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Manager"
                        id={`projectManager`}
                        readOnly={true}
                        defaultVal={!!billingApprovalProjectInfo ? billingApprovalProjectInfo?.currentManager : ''}
                        name={`projectManager`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '55%' }}
                        bodyStyle={{ width: '55%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Org Mgr/CC"
                        id={`orgMgrCc`}
                        name={`orgMgrCc`}
                        readOnly={true}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '40%' }}
                        bodyStyle={{ width: '40%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Approval Status"
                        readOnly={true}
                        id={`approvalStatus`}
                        defaultVal={!!billingApprovals ?
                            getStatusString(billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus?.toString()) : ''}
                        style={{ width: '50%', color: 'black', backgroundColor: (!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '1' ? '#66FF00' :
                            ((!!billingApprovals ?
                                billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '2' ? '#CC5500' :
                                ((!!billingApprovals ?
                                    billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '3' ? '#B22222' : '#26F7FD'))}}                            
                        name={`approvalStatus`}
                        type="text"
                        register={register}
                        errors={errors}
                        bodyStyle={{ width: '50%' }}
                    />
                </FormRow>
                <FormRow
                    style={{justifyContent: 'center'}}
                >
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Move to First Record"
                        reactIcon={BiArrowToLeft}
                        iconHoverColor="blue"
                        iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => moveToFirstRecord}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Move to Previous Record"
                        reactIcon={BiLeftArrowAlt}
                        iconHoverColor="blue"
                        iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => moveToPreviousRecord()}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Move to Next Record"
                        reactIcon={BiRightArrowAlt}
                        iconHoverColor="blue"
                        iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => moveToNextRecord()}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Move to Last Record"
                        reactIcon={BiArrowToRight}
                        iconHoverColor="blue"
                        iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={moveToLastRecord}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title={(!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '1' ? 'Revoke Approval' : 'Approve'}
                        reactIcon={(!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '1' ? FaUndo : FaCheckCircle}
                        iconHoverColor="blue"
                        iconStyle={{fill: (!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '1' ? 'blue' : 'green', width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => onApprovalStatus(Number(billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus))}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title={(!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '3' ? 'View Notes' : 'Flag'}
                        reactIcon={(!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '3' ? FaPenSquare : FaFlag}
                        iconHoverColor="blue"
                        iconStyle={{fill: (!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '3' ? 'darkblue' : 'red', width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => ((!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '3' ? showFlagNotesDialog() : showFlagReasonDialog())}
                    />
                    <Button
                        style={{ display: (!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') !== '3' ? '' : 'none',  height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="View Notes"
                        reactIcon={FaPenSquare}
                        iconHoverColor="blue"
                        iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => showFlagNotesDialog()}
                    />
                </FormRow>
            </Form>
        </>);
    };

    const displayTimeAndExpenses = () => {
        return <div>
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>No.</th>
                        <th>Acct</th>
                        <th>Days</th>
                        <th>Pd. Days</th>
                        <th>Bill Rate</th>
                        <th>Pay Rate</th>
                        <th>Services</th>
                        <th>Miles</th>
                        <th>Mileage</th>
                        <th>Meals</th>
                        <th>Hotel</th>                        
                        <th>Copies</th>
                        <th>Phone</th>
                        <th>Abstract</th>
                        <th>Postage</th>
                        <th>Shipping</th>
                        <th>Other</th>
                        <th>Expenses</th>
                    </tr>
                </thead>
                <tbody style={{width: '100%', maxHeight: '30vh', overflowY: 'scroll'}}>
                {billingExpenses?.length > 0 && billingExpenses?.map(
                    (x: TimeAndExpense, index: number) => {
                    return (
                        <>
                            <tr className="table-item-hover" style={{ textAlign: 'center' }}>
                                <td style={{ width: '12%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`timeAndExpenseData[${index}].name`}
                                        defaultVal={x?.name}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%', background: '#d5f7f5' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '6%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].number`}
                                        readOnly={true}
                                        defaultVal={x?.number?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '7%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].acctNo`}
                                        readOnly={true}
                                        defaultVal={x?.acctNo?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '7%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].days`}
                                        readOnly={true}
                                        defaultVal={x?.days?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{  width: '5%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].periodDays`}
                                        readOnly={true}
                                        defaultVal={x?.periodDays?.toString()}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].billRate`}
                                        readOnly={true}
                                        defaultVal={x?.billRate?.toString()}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].payRate`}
                                        readOnly={true}
                                        defaultVal={x?.payRate?.toString()}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].billedServices`}
                                        readOnly={true}
                                        defaultVal={x?.billedServices?.toString()}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '7%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].miles`}
                                        readOnly={true}
                                        defaultVal={x?.miles?.toString()}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].mileage`}
                                        readOnly={true}
                                        defaultVal={x?.mileage?.toString()}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].meals`}
                                        readOnly={true}
                                        defaultVal={x?.meals?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].hotel`}
                                        defaultVal={x?.hotel?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].copies`}
                                        defaultVal={x?.copies?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].phone`}
                                        defaultVal={x?.phone?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].abstract`}
                                        defaultVal={x?.abstract?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].postage`}
                                        defaultVal={x?.postage?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].shipping`}
                                        defaultVal={x?.shipping?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].other`}
                                        defaultVal={x?.other?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`timeAndExpenseData[${index}].expenses`}
                                        defaultVal={x?.expenses?.toString()}
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                            </tr>
                        </>
                    );
                })}
                
                </tbody>
            </table>
        </div>;
    };

    return (
        <div>
            <PBNavBar/>
            <ClientProjectSearch
                setSelectedClient={setSelectedClient}
                setSelectedManager={setSelectedManagerNumber}
                setSelectedPayPeriod={setSelectedPayPeriodValue}
                managers={managers}
                payPeriods={payPeriods}
                runQuery={loadData}
                size={10}
            />
            <form id="projectBillingQueryButtonsForm" onSubmit={handleSubmit(onSubmit)}>
                <Page>
                    <Page.Section width={14}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel>
                                <div className="form-row" style={{ textAlign: 'center', verticalAlign: 'middle', justifyContent: 'center', margin: 0, padding: 0 }}>
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem' }}
                                        text={'Load Data'}
                                        onClick={() => loadData()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Refresh'}
                                        onClick={() => refresh()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Reports'}
                                        onClick={() => showReportsDialog()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Expand All'}
                                        onClick={expandAllPanels}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Collapse All'}
                                        onClick={collapseAllPanels}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Excel Export'}
                                        onClick={exportToExcel}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Personnel Summary'}
                                        onClick={() => personnelSummary()}
                                    />
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page>
                    <Page.Section width={14}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle="Project Information">
                                <Form
                                    onSubmit={handleSubmit(onSubmit)}
                                >
                                    <FormRow>
{/*                                         <FormSelect
                                            label="Pay Period"
                                            name={`payPeriods`}
                                            items={!!payPeriods ? payPeriods : []}
                                            register={register}
                                            style={{ width: '60%' }}
                                            onChange={(e) => setSelectedPayPeriodValue(e.toString())}
                                        /> */}
{/*                                         <RHFSelect
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            label="Manager"
                                            id={`lmsNumber`}
                                            options={!!managers ? managers?.map((m: Landman) => {
                                                return { value: m.lmsNumber, label: m.firstName + ' ' + m.lastName };
                                            }) : [{ value: '1', label: 'Joe Shmoe'}]}
                                            name={`lmsNumber`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '60%' }}
                                            bodyStyle={{ width: '60%' }}
                                            title={selectedManager}
                                            onChange={(e) => setSelectedManager(e.currentTarget.value)}
                                        />
                                        <RHFInputBox
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            label="Client No."
                                            id={`clientNumber`}
                                            name={`clientNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '45%' }}
                                            bodyStyle={{ width: '45%' }}
                                        /> */}
                                        <RHFInputBox
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            label="Project No."
                                            id={`projectNumber`}
                                            name={`projectNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '40%' }}
                                            bodyStyle={{ width: '40%' }}
                                        />
                                        <RHFInputBox
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            label="Subcode No."
                                            id={`subcodeNumber`}
                                            name={`subcodeNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '40%' }}
                                            bodyStyle={{ width: '40%' }}
                                        />
                                        <RHFInputBox
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            label="AltSubcode No."
                                            id={`altSubcodeNumber`}
                                            name={`altSubcodeNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '40%' }}
                                            bodyStyle={{ width: '40%' }}
                                        />
                                        <RHFSelect
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            bodyStyle={{ width: '40%' }}
                                            style={{ width: '30%' }}
                                            name="office"
                                            label="Office"
                                            options={!!dlcOffices ? dlcOffices : [{ value: 1, label: 'OK'}]}
                                            register={register}
                                            errors={errors}
                                        />
                                        <RHFSelect
                                            labelOnLeft={true}
                                            bodyStyle={{ width: '40%' }}
                                            style={{ width: '50%' }}
                                            name="status"
                                            label="Status"
                                            options={statusOptionValues}
                                            register={register}
                                            errors={errors}
                                        />
                                        <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                                            <FormLabel text="Show Previous?" />
                                            <FormToggle onChange={onChangeShowPreviousBilling} name={`currentPeriodLandmen`} items={['Yes', 'No']} />
                                        </div>
                                    </FormRow>
                                </Form>
                                <CollapsibleSection
                                    title="Project Information"
                                >
                                    {displayProjectInformation()}
                                </CollapsibleSection>
                                <CollapsibleSection
                                    title="Project Billing"
                                >
                                    <Form
                                        onSubmit={handleSubmitBillingApprovalsForm(onSubmit)}
                                    >
                                        {isAccountingAdmin && displayProjectBilling()}
                                    </Form>
                                </CollapsibleSection>
                                <CollapsibleSection
                                    title="Time & Expenses"
                                >
                                    {displayTimeAndExpenses()}
                                </CollapsibleSection>
                                <CollapsibleSection
                                    title="Work Descriptions"
                                >
                                    <RHFInputBox
                                        disabled={true}
                                        label="Landman"
                                        name={`landman`}
                                        type="number"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                    />
                                    <RHFInputBox
                                        disabled={true}
                                        label=""
                                        name={`Landman2`}
                                        type="number"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                    />
                                    <RHFInputBox
                                        disabled={true}
                                        label="Project Hours"
                                        name={`projectHours`}
                                        type="number"
                                        register={register}
                                        errors={errors}
                                        readOnly={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                    />
                                </CollapsibleSection>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <FindManagerDialog
                    dialogName={'Find Manager'}
                    hideDialog={hideDialog}
                    populateManagerList={getManagers}
                    managerList={managers}
                />
                <ExcelFileDialog
                    dialogName={DialogList.EXCEL_FILE}
                    hideDialog={hideDialog}
                />
                <FlagNoteDialog 
                    dialogName={DialogList.FLAG_REASON_DIALOG} 
                    hideDialog={hideDialog}
                    handleConfirm={handleFlagBillingEntry}
                    type={!!noteMode ? 1 : 0}
                />
                <ViewFlagNotesDialog 
                    dialogName={DialogList.SHOW_FLAG_NOTES_DIALOG} 
                    hideDialog={hideDialog}
                    handleConfirm={hideDialog}
                    notes={flagAndCorrectionNotes && flagAndCorrectionNotes}
                    setRelaunch={setShowViewFlagNotes}
                    setNoteMode={setNoteMode}
                />
            </form>
        </div>
    );
};

export default ProjectBillingPage;



// WEBPACK FOOTER //
// ./src/components/project-billing/pages/ProjectBillingPage.tsx